import Select from 'assembly/parts/blocks/select/select';

Select.create = ($select, size, fill, classes, label, isInput = false) => {
	$select.each(function() {
		var $control = $(this);

		if ($control.hasClass('select__control') || !$control.is('select')) {
			return;
		}

		var $select = $(window.elkitorg_config.select_html);
		$select.addClass(classes);
		$control.replace($select);
		$control.addClass('select__control');
		$select.find('.select__control').replaceWith($control);

		if (isInput) {
			const $content = $select.find('.select__content');
			const $input = $(`<input class="select__content select__content_input" type="text" data-value="${$content.data('value')}"  value="${$content.text()}"/>`)

			$content.replaceWith($input);
		}

		if (size) {
			$select.addClass('select_size_' + size);
		}

		if (fill) {
			$select.addClass('select_fill');
		}

		if (label) {
			$select.find('.select__label').html(label);
		}

		Select($select);
	});
};

export default Select;
